module.exports = __webpack_public_path__ + "static/media/approved-password.2b69c591.svg";